var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-alert',{staticClass:"alert",attrs:{"title":_vm.title,"description":_vm.description,"type":_vm.type,"show-icon":""}})}
var staticRenderFns = []

export { render, staticRenderFns }